export const VERSION = "1.19.0";